export default __webpack_public_path__ + "static/media/male_1.2d7a1275.png";